(() => {

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5e56"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5e56"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5lCsN", function(module, exports) {
const bar = document.querySelector('.impact-bar');
if (!bar) return;
// Configuration: change these to the store/namespace/key you want
const store = "organicup-allmatters";
const namespace = "custom";
const key = "impact_campaign_quantity_reached";
// Function to fetch metafield data
async function fetchMetafield() {
    try {
        const url = `https://netlify.blacklemon.dk/.netlify/functions/getShopMetafields?store=${store}&namespace=${namespace}&key=${key}`;
        const response = await fetch(url);
        const data = await response.json();
        if (data?.metafield) {
            console.log("Metafield data returned", data.metafield.value);
            displayMetafield(data.metafield.value);
        } else console.warn("No metafield data returned", data);
    } catch (error) {
        console.error("Error fetching metafield:", error);
    }
}
// Function to display metafield value on page
function displayMetafield(metafield) {
    const goal = bar.dataset.goal;
    let progress = (Number(metafield) / Number(goal) * 100).toFixed(0);
    if (progress > 100) {
        progress = 100;
        console.log("Progress is greater than 100");
    }
    bar.querySelector('.impact-bar__progress-inner').style.width = progress + '%';
    bar.querySelector('.impact-bar__tooltip').style.left = progress + '%';
    bar.querySelector('.impact-bar__tooltip span').innerHTML = progress;
    bar.querySelector('.impact-bar__percentage-to-goal span').innerHTML = progress;
}
fetchMetafield();
// Repeat fetch every 15 seconds
setInterval(fetchMetafield, 15000);

});

class $c6168959d83d4878$var$SectionHeader extends HTMLElement {
    constructor(){
        super();
        this.init();
    }
    connectedCallback() {
        this.setupElements();
        this.setupEventListeners();
        this.setupResizeObserver();
        this.updateLogoVisibility();
    }
    disconnectedCallback() {
        this.cleanup();
    }
    init() {
        this.boundUpdateLogoVisibility = this.updateLogoVisibility.bind(this);
        this.boundUpdateLargeLogoHeight = this.updateLargeLogoHeight.bind(this);
        this.resizeObserver = null;
    }
    setupElements() {
        this.logoLarge = this.querySelector('.header__logo--large');
        this.logoDefault = this.querySelector('.header__logo--default');
        if (!this.logoLarge || !this.logoDefault) {
            console.warn('Logo elements not found');
            return;
        }
    }
    setupEventListeners() {
        window.addEventListener('scroll', this.boundUpdateLogoVisibility, {
            passive: true
        });
    }
    setupResizeObserver() {
        if (!this.logoLarge) return;
        // Stop any existing observer
        if (this.resizeObserver) this.resizeObserver.disconnect();
        // Create new observer for the parent element
        this.resizeObserver = new ResizeObserver((entries)=>{
            if (!entries.length) return;
            this.boundUpdateLargeLogoHeight();
        });
        // Start observing the parent element
        const images = this.logoLarge.querySelectorAll('.header__logo--image img');
        if (!images.length) return;
        const visibleImage = Array.from(images).find((image)=>window.getComputedStyle(image).display !== 'none');
        if (visibleImage) {
            this.resizeObserver.observe(visibleImage);
            // Initial height update
            this.boundUpdateLargeLogoHeight();
        }
    }
    updateLargeLogoHeight() {
        if (!this.logoLarge) return;
        const images = this.logoLarge.querySelectorAll('.header__logo--image img');
        if (!images.length) return;
        const visibleImage = Array.from(images).find((image)=>window.getComputedStyle(image).display !== 'none');
        if (!visibleImage) return;
        const imageHeight = visibleImage.offsetHeight + 15; // + 15px margin-bottom
        if (imageHeight > 0 && !this.logoLarge.classList.contains('hidden-logo')) this.logoLarge.style.height = `${imageHeight}px`;
    }
    updateLogoVisibility() {
        if (!this.logoLarge || !this.logoDefault) return;
        const isAtTop = window.scrollY <= 5;
        const isLargeLogoVisible = !this.logoLarge.classList.contains('hidden-logo');
        // Only update if state is changing
        if (isAtTop && !isLargeLogoVisible || !isAtTop && isLargeLogoVisible) {
            if (isAtTop) this.showLargeLogo();
            else this.hideLargeLogo();
        }
    }
    showLargeLogo() {
        this.logoLarge.classList.remove('hidden-logo');
        this.logoDefault.classList.add('hidden-logo');
        // Update height after the element is shown
        requestAnimationFrame(()=>this.updateLargeLogoHeight());
    }
    hideLargeLogo() {
        this.logoLarge.classList.add('hidden-logo');
        this.logoDefault.classList.remove('hidden-logo');
        this.logoLarge.style.height = 0;
    }
    cleanup() {
        window.removeEventListener('scroll', this.boundUpdateLogoVisibility, {
            passive: true
        });
        if (this.resizeObserver) this.resizeObserver.disconnect();
    }
}
// Only define the custom element if it hasn't been defined already
if (!customElements.get('section-header')) customElements.define('section-header', $c6168959d83d4878$var$SectionHeader);


parcelRequire("5lCsN");

})();
//# sourceMappingURL=parcel_scripts.js.map
